import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaLinkedinIn
} from 'react-icons/fa';

export const socialMediaLinks = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/herculeslifesciences',
    icon: FaFacebookF
  },
  {
    label: 'WhatsApp',
    href: 'https://wa.me/923327710655',
    icon: FaWhatsapp
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/herculeslifesciences',
    icon: FaInstagram
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/herculeslifesciences',
    icon: FaLinkedinIn
  }
];
